export default {
  1001: {
    default: true,
    formName: 'Pet Form 1',
    formFromUrl: '1000',
    variantFromUrl: '1',
  },
  1002: {
    formName: 'Pet Form 2',
    formFromUrl: '1000',
    variantFromUrl: '2',
  },
  1003: {
    formName: 'Pet Form 3',
    formFromUrl: '1000',
    variantFromUrl: '3',
  },
  2001: {
    formName: 'Pet Form 4',
    formFromUrl: '2000',
    variantFromUrl: '1',
  },
};
